<template>
  <div id="app">
    <div class="col">
      <calendar-event
        :events="broadcastForAMonth"
        :selectedDay="selectedDayEvents.date"
        @month-changed="handleMontChanged"
        @cur-day-changed="handleChangeCurDay">
      </calendar-event>
    </div>
    <player-status></player-status>
    <player @currentAction="updateAction"></player>
    <broadcast-list></broadcast-list>
  </div>
</template>

<script>
import { isEqualDateStr } from './tools.js'
import { mapActions, mapState } from 'vuex'

import PlayerStatus from './components/PlayerStatus'
import Player from './components/Player'
import BroadcastList from './components/BroadcastList'
import CalendarEvent from './components/CalendarEvent'
import moment from 'moment'

const baseUrl = 'http://broadcast.cmo.test'

export default {
  name: 'App',
  components: {
    CalendarEvent,
    PlayerStatus,
    Player,
    BroadcastList
  },
  data () {
    return {
      startDate: '',
      endDate: '',
      selectedDayEvents: {
        date: 'all',
        events: this.broadcastForAMonth || [] // default show all event
      }
    }
  },
  mounted () {
    this.setBroadcastDate(null)
  },
  computed: {
    ...mapState(['broadcastForAMonth'])
  },
  methods: {
    ...mapActions([
      'setBroadcast',
      'setBroadcastForAMonth',
      'setCurrentAudio',
      'setPlaylist'
    ]),
    updateAction (action) {
      this.playerAction = action
    },
    handleChangeCurDay (date) {
      let events = this.broadcastForAMonth.filter(function (event) {
        return isEqualDateStr(event.date, date)
      })

      if (events.length > 0) {
        this.getBroadcast(date)
        this.selectedDayEvents = {
          date: date,
          events: events
        }
      }
    },
    getBroadcast (date) {
      const self = this
      const newDate = moment.utc(date, 'YYYY/M/D')
      const selectDate = newDate.format('YYYY-MM-DD')

      const url = baseUrl + `/wp-json/myaudio/v1/day?date=${selectDate}`

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          self.setBroadcast(data)
          self.setPlaylist(data[0].playlist)
          self.setCurrentAudio(data[0].playlist[0])
        })
    },
    setBroadcastDate (curYearMonth) {
      const self = this
      self.setDateRange(curYearMonth)
      const url = `${baseUrl}/wp-json/myaudio/v1/all?after=${self.startDate}&before=${self.endDate}`

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const events = self.formatEvent(data)
          self.setBroadcastForAMonth(events)

          if (events.length > 0) {
            const lastEvent = events[0]
            self.handleChangeCurDay(lastEvent.date)
          }
        })
    },
    setDateRange (date) {
      const self = this

      if (date === null) {
        self.startDate = moment.utc().startOf('month').format()
        self.endDate = moment.utc().endOf('month').format()
        return
      }

      self.startDate = moment.utc(date, 'MM/YYYY').startOf('month').format()
      self.endDate = moment.utc(date, 'MM/YYYY').endOf('month').format()
    },
    handleMontChanged (curYearMonth) {
      const self = this
      self.setBroadcastDate(curYearMonth)
    },
    formatEvent (data) {
      return data.map((item) => {
        return {
          date: moment(item.date).startOf('day').format('YYYY/M/D'),
          title: item.title
        }
      })
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/combine/npm/bootstrap@4.1.2/dist/css/bootstrap.min.css,npm/animate.css@3.6.1/animate.min.css');

body {
  background-color:#0665a2;
  color:#fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue